import React, { useState, useEffect, useCallback } from 'react';

import useStoreTranslation from 'hooks/useStoreTranslation';
import useToast from 'hooks/useToast';
import { extractErrorMessage } from 'utils/generic';

import { fetchTripPreference, TripPreference, saveTripPreference } from '../../services/preferenceService';
import TravelerTripPreferences from '../components/TravelerTripPreferences';

const TravelerTripPreferencesContainer = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [preference, setPreference] = useState<TripPreference>();
  const toast = useToast();
  const { t } = useStoreTranslation();

  useEffect(() => {
    const fetch = async () => {
      try {
        const result = await fetchTripPreference();
        setPreference(result);
      } catch (error) {
        toast.add({ type: 'danger', message: extractErrorMessage(error) || t('defaultError.default') });
      } finally {
        setIsLoading(false);
      }
    };

    fetch();
  }, [t, toast]);

  const handleSave = useCallback(async (data: TripPreference) => {
    await saveTripPreference(data);
  }, []);

  return <TravelerTripPreferences preference={preference} save={handleSave} isLoading={isLoading} />;
};

export default TravelerTripPreferencesContainer;
